export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_FAILD = "REGISTER_USER_FAILD";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_GOOGLE = "LOGIN_USER_GOOGLE";
export const LOGIN_USER_FAILED = "LOGIN_USER_FAILED";

export const CHECK_MEMBER_RESULT = "CHECK_MEMBER_RESULT";

export const OTP_CHECK_RESULT = "OTP_CHECK_RESULT";

// Find Contact Types
export const FIND_PHONE_BY_EMAIL = "FIND_PHONE_BY_EMAIL";
export const FIND_EMAIL_BY_PHONE = "FIND_EMAIL_BY_PHONE";
export const FIND_PHONE_BY_EMAIL_FAILED = "FIND_PHONE_BY_EMAIL_FAILED";
export const FIND_EMAIL_BY_PHONE_FAILED = "FIND_EMAIL_BY_PHONE_FAILED";
export const ADD_USER_PHONE = "ADD_USER_PHONE";
export const NORMALIZE_USER_PHONE = "NORMALIZE_USER_PHONE";
export const ADD_USER_PHONE_FAILED = "ADD_USER_PHONE_FAILED";
export const NORMALIZE_USER_PHONE_FAILED = "NORMALIZE_USER_PHONE_FAILED";
